// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.condition-banner {
    cursor: default;
    background-color: #e6edff;
    transition: background-color 0.5s ease;
    overflow: hidden;
    position: relative;
    z-index: 0;
}
.condition-banner:hover {
    cursor: default;
    background-color: #abcae4;
    transition: background-color 0.5s ease;
    overflow: hidden;
    position: relative;
    z-index: 0;
}
.alphabet {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    font-size: 2em;
    font-weight: 500;
    text-align: center;
    width: 100%;
    gap: 0px;
    z-index: 1;
}
.alphabet-letters {
    flex: 1;
    cursor: pointer;
    color: #12578E;
    padding: 10px;
    transition: background-color 0.4s ease;
}
.alphabet-letters:hover {
    flex: 1;
    cursor: pointer;
    color: #12578E;
    background-color: #CCE7FF;
    padding: 10px;
    transition: background-color 0.4s ease;
}
.conditions-list-container {
    background-color: rgb(248, 252, 255);
}
.conditions-list {
    display: flex;
    justify-content: center;
    font-size: 1.25rem;
    font-weight: 400;
    text-align: center;
}
.conditions-list-item {
    color: #12578E;
    padding: 10px;
    height: 100%;
    transition: background-color 0.3s ease;
}
.conditions-list-item:hover {
    color: #12578E;
    background-color: #CCE7FF;
    padding: 10px;
    height: 100%;
    transition: background-color 0.3s ease;
}
.back {
    cursor: pointer;
    display: flex;
    justify-content: center;
    font-size: 1.25rem;
    color: #12578E;
    transition: color 0.5s ease;
    transition: background-color 0.3s ease;
    padding: 10px;
    width: 100%;
}
.back:hover {
    cursor: pointer;
    display: flex;
    justify-content: center;
    font-size: 1.25rem;
    color: aliceblue;
    transition: color 0.5s ease;
    background-color: rgba(0, 0, 0, 0.1);
    transition: background-color 0.3s ease;
    padding: 10px;
    width: 100%;
}
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
    opacity: 0;
}
.fade-enter,
.fade-leave-to {
    transition: opacity 0.5s;
    opacity: 0;
}`, "",{"version":3,"sources":["webpack://./assets/css/conditionsbannerStyle.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,yBAAyB;IACzB,sCAAsC;IACtC,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;AACd;AACA;IACI,eAAe;IACf,yBAAyB;IACzB,sCAAsC;IACtC,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;AACd;AACA;IACI,aAAa;IACb,eAAe;IACf,6BAA6B;IAC7B,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,UAAU;AACd;AACA;IACI,OAAO;IACP,eAAe;IACf,cAAc;IACd,aAAa;IACb,sCAAsC;AAC1C;AACA;IACI,OAAO;IACP,eAAe;IACf,cAAc;IACd,yBAAyB;IACzB,aAAa;IACb,sCAAsC;AAC1C;AACA;IACI,oCAAoC;AACxC;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,cAAc;IACd,aAAa;IACb,YAAY;IACZ,sCAAsC;AAC1C;AACA;IACI,cAAc;IACd,yBAAyB;IACzB,aAAa;IACb,YAAY;IACZ,sCAAsC;AAC1C;AACA;IACI,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,cAAc;IACd,2BAA2B;IAC3B,sCAAsC;IACtC,aAAa;IACb,WAAW;AACf;AACA;IACI,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,2BAA2B;IAC3B,oCAAoC;IACpC,sCAAsC;IACtC,aAAa;IACb,WAAW;AACf;AACA;;IAEI,wBAAwB;IACxB,UAAU;AACd;AACA;;IAEI,wBAAwB;IACxB,UAAU;AACd","sourcesContent":[".condition-banner {\n    cursor: default;\n    background-color: #e6edff;\n    transition: background-color 0.5s ease;\n    overflow: hidden;\n    position: relative;\n    z-index: 0;\n}\n.condition-banner:hover {\n    cursor: default;\n    background-color: #abcae4;\n    transition: background-color 0.5s ease;\n    overflow: hidden;\n    position: relative;\n    z-index: 0;\n}\n.alphabet {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-around;\n    font-size: 2em;\n    font-weight: 500;\n    text-align: center;\n    width: 100%;\n    gap: 0px;\n    z-index: 1;\n}\n.alphabet-letters {\n    flex: 1;\n    cursor: pointer;\n    color: #12578E;\n    padding: 10px;\n    transition: background-color 0.4s ease;\n}\n.alphabet-letters:hover {\n    flex: 1;\n    cursor: pointer;\n    color: #12578E;\n    background-color: #CCE7FF;\n    padding: 10px;\n    transition: background-color 0.4s ease;\n}\n.conditions-list-container {\n    background-color: rgb(248, 252, 255);\n}\n.conditions-list {\n    display: flex;\n    justify-content: center;\n    font-size: 1.25rem;\n    font-weight: 400;\n    text-align: center;\n}\n.conditions-list-item {\n    color: #12578E;\n    padding: 10px;\n    height: 100%;\n    transition: background-color 0.3s ease;\n}\n.conditions-list-item:hover {\n    color: #12578E;\n    background-color: #CCE7FF;\n    padding: 10px;\n    height: 100%;\n    transition: background-color 0.3s ease;\n}\n.back {\n    cursor: pointer;\n    display: flex;\n    justify-content: center;\n    font-size: 1.25rem;\n    color: #12578E;\n    transition: color 0.5s ease;\n    transition: background-color 0.3s ease;\n    padding: 10px;\n    width: 100%;\n}\n.back:hover {\n    cursor: pointer;\n    display: flex;\n    justify-content: center;\n    font-size: 1.25rem;\n    color: aliceblue;\n    transition: color 0.5s ease;\n    background-color: rgba(0, 0, 0, 0.1);\n    transition: background-color 0.3s ease;\n    padding: 10px;\n    width: 100%;\n}\n.fade-enter-active,\n.fade-leave-active {\n    transition: opacity 0.5s;\n    opacity: 0;\n}\n.fade-enter,\n.fade-leave-to {\n    transition: opacity 0.5s;\n    opacity: 0;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
